import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { actions } from '@elab/core/store/wishlist';

export class WishlistQuantitySelect extends SimpleLitElement {
    static get properties() {
        return {
            options: { type: Array },
            selected: { type: String },
            productCode: { type: String, attribute: 'product-code' },
            isOpen: { type: Boolean, attribute: false },
        };
    }

    toggleStatus() {
        if (this.options.length) {
            this.setStatus(!this.isOpen);
        }
    }

    setStatus(status) {
        this.isOpen = status;
    }

    handleClick(quantity) {
        this.dispatchEvent(
            new CustomEvent('update-product-quantity', {
                detail: {
                    productCode: this.productCode,
                    quantity,
                },
            }),
        );
        this.toggleStatus();
    }

    render() {
        const selectClass = `select ${this.isOpen ? 'select--opened' : ''}`;
        return html`
            <label
                @blur="${() => this.setStatus(false)}"
                tabindex="0"
                class="wishlist-select ${selectClass}"
            >
                <div class="select__wrapper" @click="${this.toggleStatus}">
                    <span class="select__selected-option">${this.selected}</span>
                    <span class="select__handler">
                        <i class="select__arrow"></i>
                    </span>
                </div>
                <div class="select__options-container">
                    <e2-scroll class="select__items-container" .active=${this.isOpen}>
                        <ul class="select__options">
                            ${this.options.map(
                                option => html`
                                    <li
                                        class="select__option ${option.disabled
                                            ? 'select__option--disabled'
                                            : ''}"
                                        @click="${() =>
                                            option.disabled ? {} : this.handleClick(option.value)}"
                                    >
                                        ${option.label}
                                    </li>
                                `,
                            )}
                        </ul>
                    </e2-scroll>
                </div>
            </label>
        `;
    }
}

const mapDispatchToEvents = dispatch => ({
    'update-product-quantity': ({ detail }) => dispatch(actions.updateWishlist(detail)),
});

export default () =>
    customElements.define(
        'e2-wishlist-quantity-select',
        connect(null, mapDispatchToEvents)(WishlistQuantitySelect),
    );
